import { useEffect, useState } from "react";
import axios from "axios";
import { Loader2, Lock } from "lucide-react";
import { Logo } from "./Header";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const errorText = (e) => {
  const d = e.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg).filter(Boolean).join(" ");
  return "Connexion impossible. Réessayez.";
};

const GateForm = ({ onOk }) => {
  const [pwd, setPwd] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      await axios.post(`${API}/access/login`, { password: pwd });
      onOk();
    } catch (ex) {
      setErr(errorText(ex));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="mm-root min-h-screen bg-mm-paper text-mm-ink flex items-center justify-center px-6" data-testid="access-gate">
      <form onSubmit={submit} className="w-full max-w-md">
        <div className="flex items-center gap-3"><Logo /><span className="disp text-3xl">MM4S</span></div>
        <h1 className="disp mm-h1 mt-10">La Grande <span className="text-mm-red">Question</span></h1>
        <p className="mm-body mt-4">Ce site est réservé. Entrez le mot de passe pour continuer.</p>
        <label className="block mt-8">
          <span className="mm-lab">Mot de passe</span>
          <input type="password" autoFocus value={pwd} onChange={(e) => setPwd(e.target.value)} data-testid="access-password-input"
            className="mt-2 w-full border-b-2 border-mm-ink bg-transparent py-3 text-lg outline-none focus:border-mm-red transition-colors" />
        </label>
        {err && <p className="mt-3 text-sm font-bold text-mm-red" data-testid="access-error">{err}</p>}
        <button type="submit" disabled={busy || !pwd} data-testid="access-submit-btn"
          className="mt-8 w-full inline-flex items-center justify-center gap-2 bg-mm-red text-white py-4 font-bold hover:bg-mm-ink transition-colors disabled:opacity-60">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Lock className="w-4 h-4" />} Entrer
        </button>
        <p className="mm-lab text-mm-golddark mt-10">Scolarité • Santé • Sécurité • Solidarité</p>
      </form>
    </div>
  );
};

export const AccessGate = ({ children }) => {
  const [ok, setOk] = useState(null);
  useEffect(() => {
    axios.get(`${API}/access/me`).then(() => setOk(true)).catch(() => setOk(false));
  }, []);
  useEffect(() => {
    if (!ok || !window.location.hash) return;
    const t = setTimeout(() => document.getElementById(decodeURIComponent(window.location.hash.slice(1)))?.scrollIntoView(), 300);
    return () => clearTimeout(t);
  }, [ok]);
  if (ok === null) {
    return <div className="min-h-screen bg-mm-paper flex items-center justify-center" data-testid="access-loading"><Loader2 className="w-6 h-6 animate-spin text-mm-ink" /></div>;
  }
  return ok ? children : <GateForm onOk={() => setOk(true)} />;
};
